import * as types from '../constants/ActionTypes';

export function setGuidePage(page) {
  console.log('action: setGuidePage', page)
  return {
    type: types.SET_GUIDE_PAGE,
    page
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/SetGuidePage.js